<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#7e5678"
    :border="true"
    inactive-color="#979799"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>

    <!-- 视频 -->
    <van-tabbar-item to="/Video">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
                :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'"
                :alt="$t('foorter.video')"
                v-show="show !== 1"
        />
        <img
                :src="props.active ? '/img/footer/videoed.jpg' : '/img/footer/video.jpg'"
                :alt="$t('foorter.video')"
                :class="$t('foorter.video')"
                style="height: 4rem"
                v-show="show === 1"
        />
      </template>
    </van-tabbar-item>

    <!-- 彩票 -->
    <van-tabbar-item @click="goDefaultLottery">
      <span>{{ $t("foorter.game") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/game_active.jpg' : '/img/footer/game.jpg'"
          :alt="$t('foorter.subscribe')"
          v-show="show !== 2"
        />
        <img
          :src="props.active ? '/img/footer/game_active.jpg' : '/img/footer/game.jpg'"
          :alt="$t('foorter.game')"
          :class="$t('foorter.subscribe')"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>

    <!-- 选妃  -->

    <van-tabbar-item to="/Choose" style="width: 25%;">
      <span class="asasa">{{ $t("foorter.choose") }}</span>
      <template #icon="props">
        <img
            :src="props.active ? '/img/footer/choose_active.jpg' : '/img/footer/choose.jpg'"
            :alt="$t('foorter.subscribe')"
            v-show="show !== 3"
        />
        <img
            :src="props.active ? '/img/footer/choose_active.jpg' : '/img/footer/choose.jpg'"
            :alt="$t('foorter.choose')"
            :class="$t('foorter.subscribe')"
            style="height: 4rem"
            v-show="show === 3"
        />
      </template>
    </van-tabbar-item>

    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'"
          :alt="$t('foorter.my')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'"
          :alt="$t('foorter.my')"
          :class="$t('foorter.my')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {
    // 跳转到资格認定页面：不写死 key/id，直接取 `Game` 列表的第一个元素
    goDefaultLottery() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
        return;
      }

      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then((res) => {
        const first = res && res.data && res.data[0];
        if (first && first.key != null && first.id != null) {
          this.$router.push({
            path: '/Lottery?key=' + first.key + '&id=' + first.id
          });
          return;
        }

        // 后备：接口返回为空时的兜底
        this.$router.push({ path: '/Lottery?key=game1&id=10' });
      });
    }
  },
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      }
      // else if (to.name == "game") {
      else if (to.name == "video") {
        this.active = 1;
        this.show = true;
      }
      // else if (to.name == "choose") {
      else if (to.name == "game" || to.name == "Lottery") {
        this.active = 2;
        this.show = true;
      }
      else if (to.name == "choose") {
        this.active = 3;
        this.show = true;
      }
      else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    }
    else if (this.$route.name == "video") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "game" || this.$route.name == "Lottery") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;
.van-tabbar {
  height: @tabbar-height;
  background: #fff1f7;
  border-top: 1px solid #f3c8de;
}
.van-tabbar-item__icon img {
  height: @tabbar-img;
}
.van-tabbar-item {
  font-size: 24px;
  background: #fff1f7;
}
::v-deep .van-tabbar-item--active {
  background: #ffe6f2;
}
.tui {
  width: 4rem;
  height: 4rem!important;
  /*margin-top: -7.333vw;*/
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}

.asasa{
  overflow: hidden;
text-overflow: ellipsis;
 white-space: nowrap;
}
</style>
